import React from "react";
import { Card, Typography, CardContent, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useForm, SubmitHandler } from "react-hook-form";
import Grid from "@mui/material/Grid";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";

import Input from "components/Input";

import { useAuth } from "context/AuthContext";
import * as Styled from "./styles";

type ForgotPasswordData = {
  userName: string;
};

const ForgotPassword = () => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ForgotPasswordData>();

  const { recoverPassword } = useAuth();

  const onSubmit: SubmitHandler<ForgotPasswordData> = async (data) => {
    await recoverPassword(data.userName);
  };

  return (
    <Styled.Container>
      <Grid
        container
        spacing={2}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: 0,
          height: "100%",
        }}
      >
        <Grid
          item
          xs={6}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Card
            sx={{
              maxWidth: 360,
            }}
          >
            <CardContent>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Styled.ArrowContainer>
                  <Styled.LinkContainer to="/">
                    <ArrowBackIcon />
                  </Styled.LinkContainer>
                  <Typography
                    sx={{ fontSize: "typography.fontsize" }}
                    color="text"
                    variant="h5"
                    fontWeight={300}
                    ml={1}
                  >
                    {t("forgotPassword")}
                  </Typography>
                </Styled.ArrowContainer>
                <Typography
                  sx={{ mb: 2 }}
                  color="text.secondary"
                  variant="subtitle1"
                  fontWeight={300}
                  fontSize="0.875rem"
                >
                  Sem problemas, te enviamos uma senha temporária.
                </Typography>

                <Input
                  name="userName"
                  error={errors.userName}
                  label="Email"
                  register={register}
                  registerOptions={{
                    required: t("requiredField"),
                    pattern: {
                      value: /^\S+@\S+$/i,
                      message: t("invalidEmail"),
                    },
                  }}
                  fullWidth
                />

                <Button
                  type="submit"
                  fullWidth
                  size="small"
                  variant="contained"
                  sx={{ mt: 2, padding: "8px 16px", borderRadius: "4px" }}
                >
                  {t("send")}
                </Button>
              </form>
            </CardContent>
          </Card>
        </Grid>
        <Grid
          item
          xs={6}
          sx={{
            paddingTop: 0,
          }}
        >
          <Styled.ContainerBackground />
        </Grid>
      </Grid>
    </Styled.Container>
  );
};

export default ForgotPassword;
